import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "size", "mode", "hideControls", "alignment", "leftElement", "rightElement", "min", "max", "step", "defaultValue", "shouldClampValueOnBlur", "shouldFocusInputOnChange", "shouldKeepWithinRange", "isAutoFocus", "isReadOnly", "isFullWidth", "isDisabled", "isInvalid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import Icon from '../Icon';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './NumericInput.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var NumericInput = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      size = _ref.size,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$hideControls = _ref.hideControls,
      hideControls = _ref$hideControls === void 0 ? true : _ref$hideControls,
      _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === void 0 ? 'left' : _ref$alignment,
      leftElement = _ref.leftElement,
      rightElement = _ref.rightElement,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? Infinity : _ref$max,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? 0 : _ref$defaultValue,
      _ref$shouldClampValue = _ref.shouldClampValueOnBlur,
      shouldClampValueOnBlur = _ref$shouldClampValue === void 0 ? true : _ref$shouldClampValue,
      _ref$shouldFocusInput = _ref.shouldFocusInputOnChange,
      shouldFocusInputOnChange = _ref$shouldFocusInput === void 0 ? true : _ref$shouldFocusInput,
      _ref$shouldKeepWithin = _ref.shouldKeepWithinRange,
      shouldKeepWithinRange = _ref$shouldKeepWithin === void 0 ? true : _ref$shouldKeepWithin,
      _ref$isAutoFocus = _ref.isAutoFocus,
      isAutoFocus = _ref$isAutoFocus === void 0 ? false : _ref$isAutoFocus,
      _ref$isReadOnly = _ref.isReadOnly,
      isReadOnly = _ref$isReadOnly === void 0 ? false : _ref$isReadOnly,
      _ref$isFullWidth = _ref.isFullWidth,
      isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isInvalid = _ref.isInvalid,
      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-numeric-input"), true), _defineProperty(_cx, "".concat(prefix, "-numeric-input--stepper"), !hideControls), _defineProperty(_cx, "".concat(prefix, "-numeric-input--left-element"), leftElement), _defineProperty(_cx, "".concat(prefix, "-numeric-input--right-element"), rightElement), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsxs(Styled.NumericInput, _objectSpread(_objectSpread({
      ref: ref,
      isDisabled: isDisabled,
      defaultValue: defaultValue,
      isInvalid: isInvalid,
      isReadOnly: isReadOnly,
      isFullWidth: isFullWidth,
      clampValueOnBlur: shouldClampValueOnBlur,
      focusInputOnChange: shouldFocusInputOnChange,
      keepWithinRange: shouldKeepWithinRange,
      min: min,
      max: max,
      step: step
    }, rest), {}, {
      children: [leftElement && _jsx(Styled.NumericInputLeftElement, {
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        children: leftElement
      }), _jsx(Styled.NumericInputField, {
        alignment: alignment,
        className: className,
        autoFocus: isAutoFocus
      }), rightElement && _jsx(Styled.NumericInputRightElement, {
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        className: cx(_defineProperty({}, "".concat(prefix, "-numeric-input--stepper"), !hideControls)),
        children: rightElement
      }), !hideControls && _jsxs(Styled.NumericInputStepper, {
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        children: [_jsx(Styled.NumericIncrementStepper, {
          children: _jsx(Icon, {
            icon: "chevron-up"
          })
        }), _jsx(Styled.NumericDecrementStepper, {
          children: _jsx(Icon, {
            icon: "chevron-down"
          })
        })]
      })]
    }))
  });
});
NumericInput.displayName = 'NumericInput';
export default NumericInput;